import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import DesignFolderSave from "./DesignFolderSave";
import DesignFolderSaveMaterials from "./DesignFolderSaveMaterials";
import GetAddresses from "./DesignFolderGetAddresses";


const DesignFolderNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    let response30 = useInvoke("WebApps", "30", null);
    let response69 = useInvoke("WebApps", "69", null);
    let response34 = useInvoke("WebApps", "34", null);
    let response37 = useInvoke("WebApps", "37", null);
    let response51 = useInvoke("WebApps", "51", null);

    const [siteLocations, setSiteLocations] = useState([]);
    const [customerLocations, setCustomerLocations] = useState([]);
    const [materialsHandled, setMaterialsHandled] = useState([]);
    const [entryFactors, setEntryFactors] = useState([]);

    useEffect(() => {

        //Get Customers
        if (response30.data.payload != undefined) {
            let data = JSON.parse(response30.data.payload).data;

            let select = document.getElementById("customerId");
            resetDropdownList("customerId");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Customer";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(customer => {
                let option = document.createElement('option');
                option.text = `${customer[1]} (${customer[3]}, ${customer[4]}, ${customer[5]}, ${customer[6]})`;
                option.value = customer[0];
                select.options.add(option);
            });
        }
        
        //Get Materials 
        if (response34.data.payload != undefined) {
            let data = JSON.parse(response34.data.payload).data;

            let materials = [];
            data.forEach((material, index) => {

                materials.push({key: index, text: `${material[1]}`, value: `${material[0]}`});
            });
            setMaterialsHandled(materials);
        }
        
        //Get Entry Factors
        if (response37.data.payload != undefined) {
            let data = JSON.parse(response37.data.payload).data;

            let select = document.getElementById("EntryFactorId");
            resetDropdownList("EntryFactorId");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Entry Factor";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(factor => {
                let option = document.createElement('option');
                option.text = factor[1];
                option.value = factor[0];
                select.options.add(option);
            });
        }

            //Get Engineers
            if (response51.data.payload != undefined) {
                let data = JSON.parse(response51.data.payload).data;
    
                let select = document.getElementById("UserId");
                resetDropdownList("UserId");
    
                let defaultOption = document.createElement('option');
                defaultOption.text = "Select Engineer";
                defaultOption.value = "";
                select.options.add(defaultOption);
    
                data.forEach(user => {
                    let option = document.createElement('option');
                    option.text = `${user[1]} ${user[2]}`;
                    option.value = user[0];
                    select.options.add(option);
                });
            }

    }, [response30.isPending, response69.isPending, response34.isPending, response37.isPending, response51.isPending]);

    const resetDropdownList = (targetID) => {

        //clear options
        let select = document.getElementById(targetID);
        for (let i = select.options.length - 1; i >= 0; i--) {
            select.remove(i);
        }

    };

    const handleCustomerSelect = (e) => {
        
        let customerSelection = e.target.value;
        
        GetAddresses(customerSelection)
        .then((response) => {
            let breakpoint = "";
            let addresses = JSON.parse(response.payload).data;
            setCustomerLocations(addresses);
        })

        
    };

    //adjust location options according to customer selection
    useEffect(() => {

        resetDropdownList("AddressID");
        let select = document.getElementById("AddressID");

        let defaultOption = document.createElement('option');
        defaultOption.text = "Select Location";
        defaultOption.value = "";
            select.options.add(defaultOption);
        
        //populate dropdown list
        customerLocations.forEach((c, index) => {

            let option = document.createElement('option');
            option.text = `${c[2]} (${c[4]}, ${c[5]}, ${c[6]})`;
            option.value = c[0];
            select.options.add(option);
        });

    }, [customerLocations]);

    const handleFormSubmit = (e) => {

        let designfolderid = "";

        let valid = true;
         
        let userid = "UserId"; 
        if (document.getElementById("UserId").value == "") {
            valid = false; 
            toast.error("Engineer required");
        }
        else {
            userid = document.getElementById("UserId").value;
        }

        let entryfactorid = ""; 
        if (document.getElementById("EntryFactorId").value == "") {
            valid = false; 
            toast.error("Entry Factor required");
        }
        else {
            entryfactorid = document.getElementById("EntryFactorId").value;
        }

        let velocity = ""; 
        if (document.getElementById("Velocity").value == "") {
            valid = false; 
            toast.error("Velocity required");
        }
        else {
            velocity = document.getElementById("Velocity").value;
        }

        let entrysize = ""; 
        if (document.getElementById("EntrySize").value == "") {
            valid = false; 
            toast.error("Entry Size required");
        }
        else {
            entrysize = document.getElementById("EntrySize").value;
        }

        let notes = document.getElementById("Notes").value; 

        let modifiedbyid = user["id"];
        let deleted = "0";

        let referencenum = "";
        if (document.getElementById("ReferenceNum").value == "") {
            valid = false; 
            toast.error("Compass Reference Number required");
        }
        else {
            referencenum = document.getElementById("ReferenceNum").value;
        }

        let customerreferencenum = "";
        if (document.getElementById("CustomerReferenceNum").value == "") {
            valid = false; 
            toast.error("Customer Reference Number required");
        }
        else {
            customerreferencenum = document.getElementById("CustomerReferenceNum").value;
        }

        let address = ""; 
        if (document.getElementById("AddressID").value == "") {
            valid = false; 
            toast.error("Site Location required");
        }
        else {
            address = document.getElementById("AddressID").value;
        }

        let materialdetails = "";
        if (document.getElementById("MaterialDetails").value.length > 1000) {
            valid = false; 
            toast.error("Material Notes cannot exceed 1000 characters");
        }
        else {
            materialdetails = document.getElementById("MaterialDetails").value;
        }

        let elevation = document.getElementById("elevation").value;
        
        if (valid) {
          DesignFolderSave(designfolderid, userid, entryfactorid, velocity, entrysize, notes, modifiedbyid, deleted, referencenum, customerreferencenum, address, materialdetails, elevation)
          .then((response) => {
                var breakpoint = "";
                if (response) {
                    return JSON.parse(response.payload).data[0][0];
                    // toast.success('Saved Successfully');
                    // navigate("/");
                }
                else {
                    toast.error('Failed to save');
                }
          })
          .then((newID) => {
            materialsHandled.forEach((material, index) => {
                if (document.getElementById(`cbMat_${index}`).checked) {
                    let designfoldermaterialhandledid = "";
                    let designfolderid = newID;
                    let materialhandledid = document.getElementById(`cbMat_${index}`).value;
                    let modifiedbyid = user["id"];
                    let deleted = "0";
                    DesignFolderSaveMaterials(designfoldermaterialhandledid, designfolderid, materialhandledid, modifiedbyid, deleted);
                }
            });
            toast.success('Saved Successfully');
            navigate("/");
          });
        }
    };

    document.title = "Design Folder - New";
    return ( 
        <div className="designFolderNew">

            {user["email"] != undefined && 
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                        <h2>New Design Project</h2>
                        <form id="designFolderForm" noValidate="novalidate" autoComplete="off">
                            
                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="UserId">Design Engineer</label>
                                </span>
                                <select className="form-control right_col valid" id="UserId" name="UserId" >
                                </select>
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="customerId">Customer</label>
                                </span>
                                <select className="form-control right_col" id="customerId" name="customerId" onChange={handleCustomerSelect}></select>
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="AddressID">Project Site Location</label>
                                </span>
                                <select className="form-control right_col" id="AddressID" name="AddressID">
                                    <option>Select Location</option>
                                </select>
                            </div>

                            <div className="form-inline" style={{marginTop: "5px"}}>
                                <span className="input-group-addon left_col" style={{height: "50px"}}>
                                    <label htmlFor="Notes">Project Notes</label>
                                </span>
                                <textarea className="form-control right_col" cols="20" id="Notes" name="Notes" rows="2" style={{height: "50px"}}></textarea>
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                Materials
                                </span>

                                <div className="right-col" style={{width: "675px"}}>
                                {materialsHandled && materialsHandled.map((mh) => (
                                    <div className="form-control" key={mh["key"]} style={{width: "225px", padding: "8px", display: "inline-flex"}}>
                                        <input value={mh["value"]} type="checkbox" id={`cbMat_${mh["key"]}`}/>
                                        <label htmlFor={`cbMat_${mh["key"]}`}>
                                        &nbsp;{mh["text"]}
                                        </label>
                                    </div>
                                    
                                ))}
                                </div>
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col" style={{height: "50px"}}>
                                <label htmlFor="MaterialDetails">Material Notes</label>
                                </span>
                                <textarea className="form-control right_col" cols="20" id="MaterialDetails" name="MaterialDetails" rows="2" style={{height: "50px"}}></textarea>
                            </div>

                            <div className="form-inline" style={{marginTop: "5px"}}>
                                <span className="input-group-addon left_col">
                                <label htmlFor="Velocity">Velocity</label>
                                </span>
                                <input className="form-control right_col" id="Velocity" name="Velocity" type="number" pattern=" 0+\.[0-9]*[1-9][0-9]*$" defaultValue="0"autoComplete="off" />
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="EntrySize">Entry Diameter (inches)</label>
                                </span>
                                <input className="form-control right_col" type="number" pattern=" 0+\.[0-9]*[1-9][0-9]*$" id="EntrySize" name="EntrySize" defaultValue="0" autoComplete="off" />
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="EntryFactorId">Entry Loss Factor</label>
                                </span>
                                <select className="form-control right_col" id="EntryFactorId" name="EntryFactorId"></select>
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="elevation">Site Elevation</label>
                                </span>
                                <input className="form-control right_col" type="number" pattern=" 0+\.[0-9]*[1-9][0-9]*$" id="elevation" name="elevation" defaultValue="0" autoComplete="off" />
                            </div>

                            <div className="form-inline" style={{marginTop: "5px"}}>
                                <span className="input-group-addon left_col">
                                <label htmlFor="ReferenceNum">Compass Reference #</label>
                                </span>
                                <input className="form-control right_col" id="ReferenceNum" name="ReferenceNum" type="text" autoComplete="off" />
                            </div>

                            <div className="form-inline">
                                <span className="input-group-addon left_col">
                                <label htmlFor="CustomerReferenceNum">Customer Reference #</label>
                                </span>
                                <input className="form-control right_col" id="CustomerReferenceNum" name="CustomerReferenceNum" type="text" autoComplete="off" />
                            </div>

                            <input id="MaterialString" name="MaterialString" type="hidden" autoComplete="off" />
                            <input name="__RequestVerificationToken" type="hidden" value="VSh_kRERXBl2WW-YoOLqw2XGZLy3Xk5Z8w6vi5tsFsl8Ls3h6wTPE5NGB7zSXpcDHUBTB7uLAutse7kg-BF5hFV0fv-yiIsua0qMzU3ohsezzCLRLnhsFZsVg9btOzAnoBkzMbecWkMby6y0vMBE8g2" autoComplete="off" />    
                        </form>
                        <Link to="/DesignFolder" className="btn btn-default" style={{marginTop: "10px", marginRight: "8px"}}>Cancel</Link>
                        <button onClick={handleFormSubmit} className="btn btn-success" style={{marginTop: "10px", marginRight: "8px"}}>Save</button>                        
                    </div>
                </>
            }
        </div>

     );
}
 
export default DesignFolderNew;